/**
 * Enumeration of user group types.
 */
export enum UserGroupEnum {
  None = 0,
  Rater = 1,
  Participant = 2,
  ClientAdmin = 3,
  SurveyAdmin = 4,
  AccountAdmin = 5,
  SysAdmin = 100,
}
